export const CORE_ACTIVITIES_NAME = "core-activities";

export enum CoreActivitiesComponent {
  //Pages
  SearchPage = "SearchPage",

  //Search
  ActivitySearch = "ActivitySearch",
  HomePageActivitySearch = "HomePageActivitySearch",
  ActivityLocationAutocomplete = "ActivityLocationAutocomplete",
  DateRangePicker = "DateRangePicker",

  //Availability
  AvailabilityPage = "AvailabilityPage",
  ActivityAvailabilitySearch = "ActivityAvailabilitySearch",
  ActivityAvailabilityTitle = "ActivityAvailabilityTitle",
  ActivityList = "ActivityList",
  ActivityListLoading = "ActivityListLoading",
  ActivityListError = "ActivityListError",
  ActivityListSort = "ActivityListSort",
  ActivityListFilter = "ActivityListFilter",
  ActivityListFilterDialog = "ActivityListFilterDialog",
  ActivityListFilterDialogContent = "ActivityListFilterDialogContent",
  ActivityListFilterDialogContentItem = "ActivityListFilterDialogContentItem",
  ActivityCard = "ActivityCard",
  ActivityCardLoading = "ActivityCardLoading",
  ActivityCardNotAvailableTag = "ActivityCardNotAvailableTag",
  ActivityCardPrice = "ActivityCardPrice",
  ActivityListItem = "ActivityListItem",
  ActivityCategoryList = "ActivityCategoryList",
  Filters = "Filters",
  FilterDialog = "FilterDialog",
  FilterList = "FilterList",
  FilterTripAdvisorRating = "FilterTripAdvisorRating",
  FilterTimeOfDay = "FilterTimeOfDay",
  FilterDuration = "FilterDuration",
  FilterCategories = "FilterCategories",
  FilterPopularFeatureTags = "FilterPopularFeatureTags",
  TripAdvisorRating = "TripAdvisorRating",
  ActivitySort = "ActivitySort",

  //Shop
  ActivityLink = "ActivityLink",
  ShopPage = "ShopPage",
  ActivityInfoSection = "ActivityInfoSection",
  ActivityOverviewSection = "ActivityOverviewSection",
  ActivityShopSection = "ActivityShopSection",
  ActivityInclusionsSection = "ActivityInclusionsSection",
  ActivityMeetupSection = "ActivityMeetupSection",
  ActivityShopMap = "ActivityShopMap",
  ActivityReviewsSection = "ActivityReviewsSection",
  ActivityItinerarySection = "ActivityItinerarySection",
  ActivityItineraryLineItem = "ActivityItineraryLineItem",
  ActivityAdditionalInformationSection = "ActivityAdditionalInformationSection",
  CustomerReview = "CustomerReview",
  CustomerReviewsSection = "CustomerReviewsSection",
  ActivityShopBookingSection = "ActivityShopBookingSection",
  ActivityShopSearch = "ActivityShopSearch",
  ParticipantPicker = "ParticipantPicker",
  DatePicker = "DatePicker",
  ActivityBookingDetailsSection = "ActivityBookingDetailsSection",
  ActivityBookingOptions = "ActivityBookingOptions",
  ActivityBookingOption = "ActivityBookingOption",
  ActivityTimeSlots = "ActivityTimeSlots",
  ActivityShopTabs = "ActivityShopTabs",

  //Shared
  CancellationBanner = "CancellationBanner",
  ActivityPriceBreakdown = "ActivityPriceBreakdown",
  PricePerTravellerBreakdown = "PricePerTravellerBreakdown",
  NoActivityAvailability = "NoActivityAvailability",

  //Checkout
  LanguageSelect = "LanguageSelect",

  //Post-booking / Trips
  ActivityReservationCard = "ActivityReservationCard",
  ActivityReservationPage = "ActivityReservationPage",
}
